import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { JpMeter } from "./JpMeter";


export class JpMeterComponent extends AbstractDisplayComponent {
    public container: JpMeter;

    public override init() {
        let containerConfig = {
            labelName: "feature_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 0,
                posY: 0,
                scale: 1,
            },
            portrait: {
                posX: 0,
                posY: 0,
                scale: 1,
            }
        };
        super.init();
        this.container = new JpMeter(containerConfig);
    }

    public getInstance(): JpMeter {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

}